const AddToCartDrawerStyles = {
    baseStyle: {
        main: {
            footer: {
                display: {base: 'block', md: 'none'},
                width: 'full',
                borderTop: '1px solid',
                background: 'white',
                borderColor: 'gray.500',
                padding: '20px 20px 10px 20px'
            },
            content: {
                borderRadius: '0 !important',
                height: '100%',
                maxHeight: '100%',
                width: {base: '372px', lg: '529px'},
                maxWidth: {base: '366px', lg: '529px'}
            },
            closeIconWrapper: {
                position: 'absolute',
                top: '10px',
                right: '10px',
                padding: '15px',
                borderRadius: '50%',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                _hover: {
                    backgroundColor: 'gray.100'
                }
            },
            drawerBody: {
                padding: {base: '10px 25px 20px 25px', md: '30px 25px'},
                className: 'add-to-cart-drawer',
                gap: '30px',
                marginTop: '40px',
                display: 'grid',
                alignContent: 'baseline',
                sx: {
                    '&::-webkit-scrollbar': {
                        width: '2px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'gray.800',
                        borderRadius: '2px',
                        display: 'block'
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'gray.400',
                        borderRadius: '2px',
                        display: 'block'
                    }
                }
            },
            heading: {
                fontWeight: '400',
                fontSize: '23px',
                color: 'black',
                marginBottom: {base: '20px', lg: '15px'}
            },
            productInfo: {
                border: '1px solid',
                borderColor: 'gray.600',
                borderRadius: '15px',
                padding: '15px',
                _hover: {
                    'h4, p': {
                        textDecoration: 'unset'
                    }
                }
            },
            productImageBox: {
                backgroundColor: 'gray.100',
                height: {base: '125px', lg: '156.25'},
                width: {base: '100px', lg: '125px'}
            },
            productImage: {
                height: {base: '125px', lg: '156.25'},
                width: {base: '100px', lg: '125px'},
                mixBlendMode: 'multiply'
            },
            progressText: {
                color: 'black.300',
                fontWeight: '300',
                fontSize: '16px',
                lineHeight: '25px',
                sx: {
                    b: {
                        fontWeight: '400'
                    }
                }
            },
            priceNameWrapper: {
                gap: '15px',
                display: 'block',
                width: {base: '164px', lg: '300px'},
                alignContent: {base: 'unset', lg: 'space-around'}
            },
            productName: {
                fontSize: '18px',
                fontWeight: '400',
                color: 'black',
                fontFamily: 'heading',
                marginBottom: '15px',
                letterSpacing: '0.09px',
                whiteSpace: 'pre-wrap'
            },
            priceWrapper: {
                gap: '10px',
                display: 'inline-flex'
            },
            productPrice: {
                fontSize: '16px',
                fontWeight: '300',
                color: 'black',
                letterSpacing: '0.08px',
                lineHeight: '25px'
            },
            salePrice: {
                fontSize: '16px',
                fontWeight: '300',
                color: 'gray.650',
                textDecoration: 'line-through !important',
                letterSpacing: '0.08px',
                lineHeight: '25px'
            },
            subtotalLabel: {
                fontSize: '16px',
                color: 'black.300',
                lineHeight: '25px',
                fontWeight: '400',
                letterSpacing: '0.08px'
            },
            subtotalValue: {
                fontSize: '16px',
                color: 'black.300',
                lineHeight: '25px',
                fontWeight: '300',
                letterSpacing: '0.08px'
            },
            viewBagButton: {
                height: '56px',
                color: 'white',
                fontSize: '17px',
                lineHeight: '26px',
                fontWeight: '400',
                borderRadius: '90px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                alignContent: 'center'
            }
        }
    }
}

export default AddToCartDrawerStyles
